module.exports = __webpack_public_path__ + "img/hopways.147a8b6a.jpeg";